$cookie-icon-url: 'https://marketing-static.signnow.com/350/images/global/modals/icon-cookie-font.png';

cookie-type-1 {
  .cookie-type-1 {
    @include desktop {
      max-width: 580px;
    }

    .cookie-type-1__content[class] {
      gap: var(--spacing-sm);
      padding: var(--spacing-md) var(--spacing-lg);
    }

    .cookie-type-1__close {
      top: 0.125rem;
      right: 0.125rem;
    }

    .cookie-type-1__description-text {
      @include text-style(xs, md);

      p,
      span,
      div {
        @include text-style(xs, md);
      }

      @include desktop {
        @include text-style(sm, lg);

        p,
        span,
        div {
          @include text-style(sm, lg);
        }
      }
    }

    .cookie-type-1__actions {
      me-button {
        display: block;
        width: 100%;
        font-size: map-get($font-sizes, sm);

        .me-button {
          width: 100%;
          font-size: map-get($font-sizes, sm);
        }
      }

      @include desktop {
        me-button {
          display: inline-flex;
          width: auto;
          font-size: inherit;

          .me-button {
            width: auto;
            font-size: inherit;
          }
        }
      }
    }

    @include desktop {
      .cookie-type-1__content[class] {
        gap: 0;
        padding: var(--spacing-md) var(--spacing-3xl) var(--spacing-md) var(--spacing-md);

        &::before {
          content: '';
          display: block;
          width: var(--spacing-lg);
          height: var(--spacing-lg);
          min-width: var(--spacing-lg);
          background-image: url($cookie-icon-url);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          flex-shrink: 0;
          align-self: flex-start;
          margin-right: 0.625rem;
        }
      }

      .cookie-type-1__actions {
        margin-left: var(--spacing-xl);
      }
    }
  }
}

[data-color-mode='signnow'] {
  cookie-type-1 {
    .cookie-type-1 {
      border-radius: map-get($border-radii, md);

      .cookie-type-1__content {
        padding: map-get($spacings, md) map-get($spacings, 5xl) map-get($spacings, md) map-get($spacings, 2xl);
        border-radius: map-get($border-radii, md);
      }

      .me-text {
        font-size: map-get($font-sizes, sm);
      }
    }
  }
}
